export const actionTypes = {
    REQUEST_LOGIN: 'REQUEST_LOGIN',
}